import React from 'react';
import { HeaderText } from 'shared-portal-component';
import '@/components/atomic/AuthHeaderText/AuthHeaderText.scss';

interface AuthHeaderTextProps {
  text: string;
}

const AuthHeaderText: React.FC<AuthHeaderTextProps> = ({text}) => (
    <HeaderText text={text} className="header-text-auth"/>

);

export default AuthHeaderText;
